import * as S from '../styles'

export function AttendantBadge({ name }: { name: string }) {
  return (
    <S.AttendantBadge>
      <span>{name}</span>
    </S.AttendantBadge>
  );
}